import { PlanoService } from 'app/app-services/plano.service';
import { FaqComponent } from './faq/faq.component';
import { FeedbackService } from 'app/utils/feedback/feedback.service';
import { TenantResolveGuard } from './app-guards/tenant.resolver';
import { CustomBrowserXhr } from './utils/custom-browser-xhr.service/custom-browser-xhr.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule, Http, XHRBackend, RequestOptions, BrowserXhr } from '@angular/http';
import { CookieModule, CookieService } from 'ngx-cookie';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada/pagina-nao-encontrada.component';

import { AutenticacaoService } from './app-services/autenticacao.service';
import { LocalStorageService } from './app-services/local-storage.service';
import { TenantService } from './app-services/tenant.service';
import { GrupoService } from './app-services/grupo.service';
import { UsuarioService } from './app-services/usuario.service';
import { NotificacaoService } from './app-services/notificacao.service';

import { AutenticacaoGuard } from './app-guards/autenticacao.guard';
import { httpClientFactory } from './utils/http-client/httpClientFactory';
import { SortablejsModule } from 'angular-sortablejs';
import { ChartsModule } from 'ng2-charts';
import { ModalModule } from './utils/modal/modal.module';
import { RestricaoTeleconsultaService } from './app-services/restricao-teleconsulta.service';
import { TeleconsultaEspecialidadeService } from './app-services/teleconsulta-especialidades.service';
import { QualificacaoGuiaMedicoCnuService } from './app-services/qualificacao.service';
import { StatusExibicaoAutorizacaoService } from './app-services/status-exibicao-autorizacao.service';
import { RestricaoAgendamentoPresencialService } from './app-services/restricao-agendamento-presencial.service';


@NgModule({
  declarations: [
    AppComponent,
    PaginaNaoEncontradaComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    CookieModule.forRoot(),
    SortablejsModule.forRoot({ animation: 150 }),
    ChartsModule,
    ModalModule.forRoot()
  ],
  providers: [

    { provide: Http, useFactory: httpClientFactory, deps: [XHRBackend, RequestOptions] },
    { provide: BrowserXhr, useClass: CustomBrowserXhr },
    AutenticacaoService,
    LocalStorageService,
    TenantService,
    AutenticacaoGuard,
    GrupoService,
    UsuarioService,
    NotificacaoService,
    TenantResolveGuard,
    FeedbackService,
    CookieService,
    PlanoService,
    TeleconsultaEspecialidadeService,
    RestricaoTeleconsultaService,
    RestricaoAgendamentoPresencialService,
    StatusExibicaoAutorizacaoService,
    QualificacaoGuiaMedicoCnuService
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts